/**
 * Calculates the correct drop index for reordering operations that use a remove-then-insert pattern.
 *
 * Accounts for the remove-then-insert nature of the reordering by adjusting the target index
 * when moving an item to a position after its original position.
 *
 * @example
 * // Moving item from index 1 to position 3 in array [A, B, C, D]
 * // Step 1: Remove B → [A, C, D] (C shifts from index 2 to 1, D shifts from index 3 to 2)
 * // Step 2: Insert B at calculateDropIndex(1, 3) = 2 → [A, C, B, D] (correct)
 * // Without adjustment: Insert B at index 3 → [A, C, D, B] (wrong - B ends up after D)
 *
 * @param fromIndex - The original index of the item being moved
 * @param toIndex - The target index where the item should be positioned
 * @returns The adjusted index to use for the insert operation
 */
export function calculateDropIndex(fromIndex, toIndex) {
  if (toIndex > fromIndex) {
    return toIndex - 1;
  }
  return toIndex;
}